import { Icon } from '@tabler/icons-react'
import { createSelector } from 'reselect'

import { pages } from '~/app/routes'
import { StoreState } from '~/store/store'

export type NavLink = {
    url: string
    title: string
    icon: Icon
}

export type NavGroup = {
    title: string
    items: NavLink[]
}

export function isNavGroup(entry: NavGroup | NavLink): entry is NavGroup {
    return 'items' in entry
}

export const selectNavLinks = createSelector(
    (state: StoreState) => state.app.activeViews,
    (activeViews): (NavGroup | NavLink)[] => [
        {
            title: 'Operasjonelt',
            items: [
                {
                    url: activeViews.OPERATIONAL_PLANNER,
                    title: pages.OPERATIONAL_PLANNER.title,
                    icon: pages.OPERATIONAL_PLANNER.icon,
                },
                {
                    url: activeViews.WAITING_LIST,
                    title: pages.WAITING_LIST.title,
                    icon: pages.WAITING_LIST.icon,
                },
            ],
        },
        {
            title: 'Taktisk',
            items: [
                {
                    url: activeViews.PERIODS_OVERVIEW,
                    title: pages.PERIODS_OVERVIEW.title,
                    icon: pages.PERIODS_OVERVIEW.icon,
                },
                {
                    url: activeViews.SURGERY_SCHEDULER,
                    title: pages.SURGERY_SCHEDULER.title,
                    icon: pages.SURGERY_SCHEDULER.icon,
                },
                {
                    url: activeViews.SURGEON_SCHEDULER,
                    title: pages.SURGEON_SCHEDULER.title,
                    icon: pages.SURGEON_SCHEDULER.icon,
                },
                {
                    url: activeViews.INSIGHTS,
                    title: pages.INSIGHTS.title,
                    icon: pages.INSIGHTS.icon,
                },
            ],
        },
    ]
)

export const selectFlatNavLinks = createSelector(selectNavLinks, (navEntries): NavLink[] =>
    navEntries.flatMap(entry => (isNavGroup(entry) ? entry.items : [entry]))
)
